import React from 'react';

import { PrismWidgetType } from 'constants/formBuilder';

import PrismDynamicFieldPicker from './PrismDynamicFieldPicker';
import PrismSignatureBridge from './PrismSignatureBridge';

export const renderPrismWidgetEditor = request => {
  if (request.widgetType === PrismWidgetType.DYNAMIC_FIELD) {
    return <PrismDynamicFieldPicker request={request} />;
  }

  if (request.widgetType === PrismWidgetType.SIGNATURE) {
    return <PrismSignatureBridge request={request} />;
  }

  return null;
};
